import { EcosystemServiceModel } from "@shared/models/ecosystem-service.model";

export const _07_WATER_TO_DRINK:Partial<EcosystemServiceModel> ={
  id:'water-to-drink',
  pos:7,
  image: "/images/ecoservices/water_to_drink.jpg",
  code: ["1.1.3.1"],
  unit:'water to drink',
  assetType:'other',
  serviceType: 'provisioning',
  valuationMethods:[
    {
      id: 'market',
      name:"Market prices",
      unit: "m3",
      element: "water to drink",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    }
  ]

}
